var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Logo"},[_c('h1',{staticClass:"sr-only"},[_vm._v("Engage")]),_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/images/logo.svg"),"alt":"Engage"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }